import type { ApexAccountsStepCompleteness } from '../types/GoWorkflow';

/**
 * True when the member has no remaining actions (no accounts to open or
 * joint invitations to accept) for the Apex step.
 */
export function memberHasNoApexActionsLeft(
    apexStep: ApexAccountsStepCompleteness | undefined,
): boolean {
    if (!apexStep?.isIncluded) {
        return false;
    }
    return (
        (apexStep.memberSoloAccountsToOpen?.length ?? 0) === 0 &&
        (apexStep.jointAccountsToOpen?.length ?? 0) === 0 &&
        (apexStep.memberJointAccountsToAccept?.length ?? 0) === 0
    );
}

/**
 * True when the member can proceed to the income split step.
 * Apex step is complete for both member and membership.
 */
export function canProceedToIncomeSplit(
    apexStep: ApexAccountsStepCompleteness | undefined,
): boolean {
    return (
        apexStep != null &&
        apexStep.isIncluded &&
        apexStep.isCompleteForMember &&
        apexStep.isCompleteForMembership
    );
}

/**
 * True when the member has completed their part but must wait for
 * their partner to accept joint account invitations.
 */
export function mustWaitForPartner(
    apexStep: ApexAccountsStepCompleteness | undefined,
): boolean {
    return (
        apexStep != null &&
        apexStep.isIncluded &&
        apexStep.isCompleteForMember &&
        !apexStep.isCompleteForMembership
    );
}
